module.exports = __webpack_public_path__ + "img/admin_icon.c3a0e6d7.png";